/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Dropzone_Select_ButtonInputs */

const en_case_dropzone_select_button = /** @type {(inputs: Case_Dropzone_Select_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select files`)
};

const pt_br2_case_dropzone_select_button = /** @type {(inputs: Case_Dropzone_Select_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar arquivos`)
};

/**
* | output |
* | --- |
* | "Select files" |
*
* @param {Case_Dropzone_Select_ButtonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_dropzone_select_button = /** @type {((inputs?: Case_Dropzone_Select_ButtonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Dropzone_Select_ButtonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_dropzone_select_button(inputs)
	return pt_br2_case_dropzone_select_button(inputs)
});